import React from 'react'
import classes from "./style.module.scss";
import { Images } from '../../../../assets';
import Button from '../../../../component/Button';
import { FormProvider, useForm } from 'react-hook-form';
import InputBox from '../../../../component/InputBox';
import { useNavigate } from 'react-router-dom';
import request from '../../../../service';
import Exported from '../../../../service/endpoints';
import { Toast } from '../../../../service/toast';
import { logout } from '../../../../service/helpers';

const ProfileCredentialManager = () => {

    const navigate = useNavigate()
    const formMethods = useForm({
        mode: 'onSubmit',
    });
    const {
        handleSubmit,
        formState: { errors },
        register,
        trigger,
        getValues,
    } = formMethods;

    const onSubmit = async (data) => {
        trigger();
        console.log(data, "request");
        let requestData = {
            password : data.currentPassword,
            newPassword : data.newPassword
        }
        await request({
            url : Exported.Endpoints.newPassword,
            method : Exported.APIMethods.POST,
            data : requestData
        }).then((res) =>{
            console.log(res)
            if(res?.data?.status){
                logout();
            }
        }).catch((err) =>{
            console.log(err)
            Toast({
                type: 'error',
                message: 'Failed to set New Password. Please try again.'
            })
        })
    };

    const redirectTo = () => {
        navigate('/admin/dashboard')
    }
    return (
        <div className={`${classes.credentialManager}`}>
            <div className={`${classes.profileTitle}`}>My Profile</div>
            <div className='py-5'>
                <div className={`${classes.profileSecurity}`}>Security Settings</div>
                <div className={`${classes.profileSecurityHeader} my-2`}>Password Management</div>
                <div className={`${classes.formContainer}`}>
                    <FormProvider {...formMethods}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className={`${classes.formGroup}`}>
                                <div className={`${classes.formField}`}>
                                    <InputBox
                                        label={"Current Password"}
                                        className={`w-[100%]`}
                                        name={"currentPassword"}
                                        type={"password"}
                                        {...register("currentPassword", {
                                            required: true,
                                            minLength: {
                                                value: 6,
                                            },
                                        })}
                                        error={errors.currentPassword}
                                        messages={{
                                            required: "Password is required",
                                            minLength: "Minimum 6 characters required",
                                        }}
                                    />
                                </div>
                                <div className={`${classes.formField}`}>
                                    <InputBox
                                        label={"New Password"}
                                        className={`w-[100%]`}
                                        name={"newPassword"}
                                        type={"password"}
                                        {...register("newPassword", {
                                            required: true,
                                            minLength: {
                                                value: 6,
                                            },
                                        })}
                                        error={errors.newPassword}
                                        messages={{
                                            required: "Password is required",
                                            minLength: "Minimum 6 characters required",
                                        }}
                                    />
                                </div>
                            </div>
                            <div className={`${classes.formGroup}`}>
                                <div className={`${classes.formField}`}>
                                    <InputBox
                                        label={"Confirm Password"}
                                        className={`w-[100%]`}
                                        name={"confirmPassword"}
                                        type={"password"}
                                        {...register("confirmPassword", {
                                            required: true,
                                            minLength: {
                                                value: 6,
                                            },
                                            validate : (value) => {
                                                const {newPassword} = getValues();
                                                return value === newPassword || "Password does not match"}
                                        })}
                                        onPaste={(e) => e.preventDefault()}
                                        onCopy={(e) =>e.preventDefault() }
                                        error={errors.confirmPassword}
                                        messages={{
                                            required: "Password is required",
                                            validate: "Passwords do not match",
                                            minLength: "Minimum 6 characters required",
                                        }}
                                    />
                                </div>
                            </div>
                            <div className={`flex justify-end ${classes.credentialActions}`}>
                                <Button text={"Cancel"} className={'mr-4'} secondary smallBtn onClick={() => redirectTo()}/>
                                <Button text={"Save"} className={''} smallBtn />
                            </div>
                        </form>
                    </FormProvider>
                </div>

            </div>
        </div>
    )
}

export default ProfileCredentialManager